import React, {useState} from "react";
import {useReadAccountList} from "../../../../pages/customer/correspondent/detail/hooks";
import {AccountSearchInterface} from "../../../../pages/customer/correspondent/list/interface/searchInterface";
import {SubmitHandler, useForm,} from "react-hook-form";
import EmptyTableRow from "../../../../pages/common/EmptyTableRow";
import {ModalInnerConfirmType} from "../interface";
import {useModal} from "../../../../hooks";
import PaginationSub from "../../pagination/PaginationSub";

type BusinessPartnerInnerItemType = {
    accountId: string;
    name: string;
    industryName: null | string;
    chargeName: string;
    defaultContact: null | string;
    customerCategoryName: string;
    erpAccountName: string;
    erpAccountCode: string;
}

export const SearchBusinessPartnerInner = ({
                                               confirmCallback,
                                               cancelCallback,
                                               modalDepth
                                           }: ModalInnerConfirmType<BusinessPartnerInnerItemType>) => {
    const defaultSearchValue = {
        limit: 10,
        pageNo: 1,
        keywordType: "0",
        keyword: "",
    };

    const {handleModal, resetModal} = useModal();

    const [searchOption, setSearchOption] =
        useState<AccountSearchInterface>(defaultSearchValue);

    const {data} = useReadAccountList({searchData: {...searchOption, stateFlag: true}});

    const [selectItem, setSelectItem] = useState<BusinessPartnerInnerItemType | null>(null);

    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<AccountSearchInterface> = (submitData) => {
        setSearchOption(submitData);
    };

    const onClose = () => {
        resetModal(modalDepth)
    }

    const onConfirm = () => {
        if (selectItem?.accountId) {
            confirmCallback(selectItem);
            onClose()
        } else {
            handleModal({
                isOpen: true,
                contents: "거래처를 선택해주세요.",
                type: "alert",
                depth: modalDepth + 1
            })
        }
    }

    const onCancel = () => {
        onClose()
        cancelCallback && cancelCallback()
    }

    const dataList = data?.data?.result?.accountVOList ?? [];
    const totalCount = data?.data?.result?.totalCount ?? 0;

    return (
        <>
            <form className="d-flex mb-15px" onSubmit={handleSubmit(onSubmit)}>
                <select className="form-select w-140px" {...register("keywordType")}>
                    <option value={"0"}>전체</option>
                    <option value={"1"}>회사명</option>
                    <option value={"2"}>담당자</option>
                    <option value={"3"}>ERP거래처</option>
                </select>
                <input
                    type="text"
                    className="form-control w-250px ms-5px h-34px"
                    {...register("keyword")}
                />
                <button type="submit" className="btn btn-info btn_search w-80px ms-5px">
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                        alt=""
                    />
                    조회
                </button>
            </form>

            <table className="table table-bordered my_table table_modal">
                <thead>
                <tr>
                    <th style={{ width: "5%" }}></th>
                    <th style={{ width: "24%" }}>회사명</th>
                    <th style={{ width: "24%" }}>ERP거래처</th>
                    <th style={{ width: "10%" }}>ERP거래처코드</th>
                    <th style={{ width: "10%" }}>소속분류</th>
                    <th style={{ width: "17%" }}>산업구분</th>
                    <th style={{ width: "10%" }}>담당자</th>
                </tr>
                </thead>
                <tbody>
                {dataList?.length === 0 ? (
                    <EmptyTableRow colSpan={6}/>
                ) : (
                    dataList?.map(
                        (item: {
                            accountId: string;
                            name: string;
                            industryName: null | string;
                            chargeName: string;
                            defaultContact: null | string;
                            customerCategoryName: string;
                            erpAccountName: string;
                            erpAccountCode: string;
                        }) => {
                            return (
                                <tr className={`clickable ${item.accountId === selectItem?.accountId ? "lightblue" : ""}`}
                                    onClick={() => setSelectItem(item)}>
                                    <td>
                                        <div className="checkbox_outer">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                onClick={() => {
                                                    setSelectItem(item);
                                                }}
                                                checked={selectItem?.accountId === item?.accountId}
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center"> {item?.name}</td>
                                    <td className="text-center">
                                        {item?.erpAccountName ?? "-"}
                                    </td>
                                    <td className="text-center"> {item?.erpAccountCode ?? "-"}</td>
                                    <td className="text-center">
                                        {item?.customerCategoryName}
                                    </td>
                                    <td className="text-center">
                                        {item?.industryName ?? "-"}
                                    </td>
                                    <td className="text-center">{item?.chargeName ?? "-"}</td>
                                </tr>
                            );
                        }
                    )
                )}
                </tbody>
            </table>

            <PaginationSub totalCount={totalCount}
                           currentPage={Number(searchOption.pageNo)}
                           onChangeCallback={(i) => setSearchOption({...searchOption, pageNo: i})}/>

            <div className="mt-3 d-flex align-items-center justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary w-100px h-38px my-0"
                    onClick={onCancel}
                >
                    취소
                </button>
                <button
                    type="button"
                    className="btn btn-dark w-100px h-38px my-0 ms-3"
                    onClick={() => {
                        onConfirm()
                        //     if (setValue && selectItem?.accountId) {
                        //         setValue("parentAccountIdValue", selectItem?.accountId, {
                        //             shouldDirty: true,
                        //         });
                        //
                        //         setValue("parentAccount", selectItem?.name, {
                        //             shouldDirty: true,
                        //         });
                        //         if (resetModal) {
                        //             resetModal();
                        //         }
                        //     } else if (setValueShipment && selectItem?.accountId) {
                        //         setValueShipment(selectItem);
                        //         if (resetModal) {
                        //             resetModal();
                        //         }
                        //     } else {
                        //         console.log("선택 or setValue 없음");
                        //     }
                    }}
                >
                    선택
                </button>
            </div>
        </>
    );
};
